import { Component, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { ScreenSize } from 'libs/portal/src/layout/layout.service';
import { CardTableOptions } from 'libs/portal/src/modules/tools/card-table/models';
import { CardTableHeader } from 'libs/portal/src/modules/tools/card-table/models/card-table-header.model';
import { GenericTableHeaderOptions } from 'libs/portal/src/modules/tools/card-table/models/generic-table-header-options.model';
import { GenericService } from 'libs/portal/src/services/generic/generic.service';
import { PaginationService } from 'libs/portal/src/services/pagination/pagination.service';
import { ToolsService } from 'libs/portal/src/services/tools/tools.service';
import { UserRightsService } from 'libs/portal/src/services/user-rights/user-rights.service';
import { Endpoints } from '@huge-monorepo/portal/config';

@Component({
  selector: 'app-relay-raw-report',
  templateUrl: './relay-raw-report.component.html',
  styleUrls: ['./relay-raw-report.component.scss'],
})
export class RelayRawReportComponent implements OnInit {
  loading = false;
  todayT = new Date();
  displayReportResults: any[] = [];
  groups: any[] = [];
  servers: any[] = [];
  serverLinks: any[] = [];
  apns: any[] = [];
  resetHeader = false;
  selectedAPN = null;
  selectedServerLinkID = 0;
  startDate: string;
  endDate: string;
  resetting = false;
  reportResults: any[] = [];
  enquired = false;
  currentPage = 0;
  ScreenSize = ScreenSize;

  authSubscription: Subscription;
  obfuscateDetails = false;

  headerOptions: GenericTableHeaderOptions = {
    ShowSearch: false,
    SearchPlaceholder: 'Search for devices',
    DefaultDesc: true,

    DateItem: {
      Singular: false,
      Title: 'Select date range',
      StartDate: this.tools.StartOfMonth().toDateString(),
      EndDate: new Date().toDateString(),
    },
    DateRequired: true,
    EnableExport: false,
    EnableSelectAll: false,
    DropDownOptions: [],
  };

  options: CardTableOptions = {
    titleProperty: 'Name',
    rowId: 'ID',
    subTitleProperty: 'data',
    additionalProperty: 'status',
    indicatorColorProperty: 'color',
    selectedProperty: 'selected',
    isSelectable: false,
    flexCardLayout: false,
    propertyRowExclusions: ['ID', 'Description'],
    stylePropertyPrefix: 'alerts',
    clickableFlexCard: false,
    textSize: 'regular',
  };

  resultsHeaders: CardTableHeader[] = [
    {
      ID: 'SourceIP',
      Index: 0,
      Sort: 'SourceIP',
      Sortable: false,
      Width: 10,
      Text: 'Source IP',
    },
    {
      ID: 'APN',
      Index: 1,
      Sort: 'APN',
      Sortable: false,
      Width: 10,
      Text: 'APN Name',
    },
    {
      ID: 'AcceptTime',
      Index: 2,
      Sort: 'AcceptTime',
      Sortable: false,
      Width: 10,
      Text: 'Accept Time',
    },
    {
      ID: 'Timestamp',
      Index: 3,
      Sort: 'Timestamp',
      Sortable: false,
      Width: 10,
      Text: 'Timestamp',
    },
    {
      ID: 'DialStart',
      Index: 4,
      Sort: 'DialStart',
      Sortable: false,
      Width: 10,
      Text: 'Dial Start',
    },
    {
      ID: 'DialEnd',
      Index: 5,
      Sort: 'DialEnd',
      Sortable: false,
      Width: 10,
      Text: 'Dial End',
    },
    {
      ID: 'ConnClosed',
      Index: 6,
      Sort: 'ConnClosed',
      Sortable: false,
      Width: 10,
      Text: 'Connection Closed',
    },
    {
      ID: 'Succeeded',
      Index: 7,
      Sort: 'Succeeded',
      Sortable: false,
      Width: 5,
      Text: 'Success',
    },
    {
      ID: 'Tx',
      Index: 8,
      Sort: 'Tx',
      Sortable: false,
      Width: 7,
      Text: 'Tx',
      Wrapper: (obj, elem) => {
        if (elem != null) {
          return Math.round(elem);
        }
        return '-';
      },
    },
    {
      ID: 'Rx',
      Index: 9,
      Sort: 'Rx',
      Sortable: false,
      Width: 7,
      Text: 'Rx',
    },
    {
      ID: 'CloseMessage',
      Index: 10,
      Sort: 'CloseMessage',
      Sortable: false,
      Width: 10,
      Text: 'CloseMessage',
    },
  ];

  constructor(
    private genericService: GenericService,
    private tools: ToolsService,
    private endpoints: Endpoints,
    private paginationService: PaginationService,
    private auth: UserRightsService,
  ) {}

  ngOnInit() {
    this.authSubscription = this.auth.GetUser().subscribe((user) => {
      const prev = this.obfuscateDetails;
      if (user.isObfuscated) {
        this.obfuscateDetails = true;
      } else {
        this.obfuscateDetails = false;
      }

      if (prev != this.obfuscateDetails) {
        this.groups = [];
        this.headerOptions.DropDownOptions = [];

        if (this.enquired) {
          this.EnquireReportInfo();
        }
      }
      this.getGroups();
    });
  }

  getGroups() {
    this.startDate = this.tools.isoDateWithoutTimeZone(this.tools.GetStartOfMonth(new Date())).toISOString();
    this.endDate = this.tools.GetEndOfDay(this.tools.isoDateWithoutTimeZone(new Date())).toISOString();
    this.genericService.GET(this.endpoints.GET_RELAY_GROUPS).subscribe((res: any) => {
      res['body'].forEach((element) => {
        if (element.GroupName == '') {
          element.GroupName = 'Unassigned';
        }
        if (this.obfuscateDetails) {
          element.GroupName = this.tools.Obfuscate(element.GroupName, 'Group ', 4);
          element.Servers.forEach((server) => {
            server.OriginalName = server.Name;
            server.Name = this.tools.Obfuscate(server.Name, 'Server ', 4);
          });
        }
        this.groups.push(element);
      });
      this.headerOptions.DropDownOptions.push({
        Label: 'Group',
        options: this.groups,
        attribute: 'GroupName',
      });
    });
  }

  updateDates(returnedDates: any) {
    if (returnedDates.valid) {
      this.startDate = returnedDates.startDate;
      this.endDate = returnedDates.endDate;
    } else {
      this.startDate = null;
      this.endDate = null;
    }
  }

  reset() {
    this.resetting = true;
    this.reportResults = [];
    this.servers = [];
    this.serverLinks = [];
    this.apns = [];
    this.resetHeader = true;
    this.groups = [];
    this.headerOptions.DropDownOptions = [];
    this.headerOptions.EnableClear = false;
    this.headerOptions.EnableView = false;
    this.getGroups();
    this.startDate = this.tools.isoDateWithoutTimeZone(this.tools.GetStartOfMonth(new Date())).toISOString();
    this.endDate = this.tools.GetEndOfDay(this.tools.isoDateWithoutTimeZone(new Date())).toISOString();
    this.headerOptions.DateItem.StartDate = this.startDate;
    this.headerOptions.DateItem.EndDate = this.endDate;

    this.selectedAPN = null;
    this.selectedServerLinkID = 0;
    this.enquired = false;

    setTimeout(() => {
      this.resetHeader = false;
      this.resetting = false;
    });
  }

  isValid(): Boolean {
    if (this.selectedServerLinkID != 0) {
      return true;
    }
    return false;
  }

  createObject(): Object {
    return {
      StartDate: this.startDate,
      EndDate: this.endDate,
      IncomingLinkID: this.selectedServerLinkID,
      APN: this.selectedAPN,
    };
  }

  EnquireReportInfo() {
    if (this.isValid()) {
      this.reportResults = [];
      this.loading = true;
      this.genericService.POST(this.endpoints.GENERATE_RAW_REPORT(true, false), this.createObject()).subscribe((results) => {
        let tempReportResults = results['body'] as any[];
        if (tempReportResults) {
          tempReportResults.forEach((element: any) => {
            this.reportResults.push({
              SourceIP: element.SourceIP,
              APN: this.obfuscateDetails ? this.tools.Obfuscate(element.APN, 'APN ', 4) : element.APN,
              AcceptTime: this.tools.FormatSwedishDateTime(this.tools.ParseAPIDate(element.AcceptTime)),
              Timestamp: this.tools.FormatSwedishDateTime(this.tools.ParseAPIDate(element.Timestamp)),
              DialStart: this.tools.FormatSwedishDateTime(this.tools.ParseAPIDate(element.DialStart)),
              DialEnd: this.tools.FormatSwedishDateTime(this.tools.ParseAPIDate(element.DialEnd)),
              ConnClosed: this.tools.FormatSwedishDateTime(this.tools.ParseAPIDate(element.ConnClosed)),
              Succeeded: element.Succeeded,
              Tx: element.Tx,
              Rx: element.Rx,
              CloseMessage: element.CloseMessage,
            });
          });
        }
        this.enquired = true;
        this.loading = false;
      });
    }
  }

  downloadReport() {
    if (this.isValid()) {
      this.loading = true;
      this.genericService.download(this.endpoints.GENERATE_RAW_REPORT(false, false), this.createObject()).subscribe((_results) => {
        this.loading = false;
        this.reset();
      });
    }
  }

  groupSelect(event: any) {
    this.apns = [];
    this.serverLinks = [];
    this.selectedAPN = '';
    this.selectedServerLinkID = 0;
    this.servers = event.Servers;
  }

  serverSelect(server: any) {
    this.genericService.GET(this.endpoints.GET_SERVER_LINKS(server.ID, 0)).subscribe((res: any) => {
      this.serverLinks = res['body'];
      if (this.serverLinks && this.serverLinks.length > 0) {
        this.serverLinks.forEach((link) => {
          if (this.obfuscateDetails) {
            link.Name = this.tools.Obfuscate(link.Name, 'Server ', 4);
          }
        });
        this.headerOptions.DropDownOptions[2] = {
          Label: 'Server Link',
          options: this.serverLinks,
          attribute: 'Name',
        };
      }
    });
  }

  serverLinkSelect(serverLink: any) {
    this.selectedServerLinkID = serverLink.ID;
    this.genericService
      .POST(this.endpoints.GET_RELAY_APNS, {
        ServerLinkIDs: [serverLink.ID],
      })
      .subscribe((res: any) => {
        this.apns = res['body'];
        this.apns.forEach((apn) => {
          apn.OriginalName = apn.Name;
          if (this.obfuscateDetails) {
            apn.Name = this.tools.Obfuscate(apn.Name, 'APN ', 4);
          }
        });
        this.headerOptions.DropDownOptions[3] = {
          Label: 'APN',
          options: this.apns,
          attribute: 'Name',
        };
      });
  }

  apnSelect(apn: any) {
    this.selectedAPN = apn.OriginalName;
  }

  updateStart(event: string) {
    this.startDate = event;
  }

  updateEnd(event: string) {
    this.endDate = event;
  }

  onPageChange(event: any) {
    console.log(event);
    this.currentPage = event;
    const startIndex = (this.currentPage - 1) * 10;
    let endIndex = startIndex + 10;
    if (endIndex > this.reportResults.length) {
      endIndex = this.reportResults.length;
    }
    setTimeout(() => {
      this.paginationService.emit();
    });
  }

  getDropdowns(event) {
    if (event.Label == 'Group') {
      this.servers = event.Value.Servers;
      this.headerOptions.EnableClear = false;
      this.headerOptions.EnableView = false;
      this.headerOptions.DropDownOptions = this.headerOptions.DropDownOptions.slice(0, 1);
      this.headerOptions.DropDownOptions[1] = {
        Label: 'Server',
        options: this.servers,
        attribute: 'Name',
      };
    } else if (event.Label == 'Server') {
      this.headerOptions.EnableClear = false;
      this.headerOptions.EnableView = false;
      this.headerOptions.DropDownOptions = this.headerOptions.DropDownOptions.slice(0, 2);
      this.serverSelect(event.Value);
    } else if (event.Label == 'Server Link') {
      this.headerOptions.EnableClear = true;
      this.headerOptions.EnableView = true;
      this.headerOptions.EnableExport = true;
      this.headerOptions.DropDownOptions = this.headerOptions.DropDownOptions.slice(0, 3);
      this.serverLinkSelect(event.Value);
    } else if (event.Label == 'APN') {
      this.apnSelect(event.Value);
    }
  }

  setDate(event: any) {
    if (event.endDate != null) {
      this.startDate = this.tools.isoDateWithoutTimeZone(new Date(event.startDate)).toISOString();
      this.endDate = this.tools.GetEndOfDay(this.tools.isoDateWithoutTimeZone(new Date(event.endDate))).toISOString();
    }
  }
}
